<cmps-ui-dropdown
    [selected]="selectedUser"
    [options]="favourites"
    [dropdownPosition]="dropdownPosition"
    [optionTemplate]="optionTpl"
    [searchResults]="searchResults"
    [searchQuery]="searchQuery"
    [searchResultTemplate]="searchResultTpl"
    [loadingTemplate]="loadingTpl"
    [loading]="loadingSearchResults"
    (opened)="handleOpen($event)"
    (selectedChange)="selectedChange($event)"
>
    <button
        viewTrigger
        [toggle]="toggleDropdown"
        class="btn change-view-button"
    >
        <cmps-icon svgIcon="pencil"></cmps-icon>
        <span>{{ i18n._7408_CHANGE_VIEW | translate }}</span>
    </button>

    <div optionsHeader>
        <button
            class="btn change-view-button default"
            (click)="setDefaultView(); toggleDropdown = !toggleDropdown"
        >
            <span>
                {{ i18n._7409_DEFAULT_VIEW__SELF_ | translate }}
            </span>
            <cmps-icon
                svgIcon="check-bold"
                *ngIf="user.id == currentView.userId"
            ></cmps-icon>
        </button>

        <form
            class="team-view-search row"
            (submit)="search()"
        >
            <div class="col-md-10">
                <input
                    #searchBox
                    type="text"
                    autocomplete="off"
                    class="form-control team-view-search-query"
                    name="searchQuery"
                    [ngModel]="searchQuery"
                    (ngModelChange)="onQuery($event)"
                    placeholder="{{ i18n._710_SEARCH | translate }}"
                />
            </div>
            <div class="col-md-2 team-view-search-button-container">
                <button
                    class="borderless-button"
                    *ngIf="!searchResults.length"
                    type="submit"
                >
                    <cmps-icon svgIcon="magnify"></cmps-icon>
                </button>
                <button
                    class="borderless-button"
                    *ngIf="searchResults.length"
                    type="button"
                    (click)="clearSearch()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </form>
    </div>

    <ng-template
        #loadingTpl
        let-loading="loading"
    >
        <cmps-wait-status *ngIf="loading == true"></cmps-wait-status>
    </ng-template>

    <ng-template
        #searchResultTpl
        let-result="result"
    >
        <div
            class="option-content col-12"
            (click)="selectedChange(result); toggleDropdown = !toggleDropdown"
        >
            <div class="row">
                <div class="option-text col-md-11">
                    {{ result.label }}
                </div>
            </div>
            <div class="row">
                <div class="option-sub-text">
                    {{ result.value }}
                </div>
            </div>
            <div class="option-actions">
                <button
                    type="button"
                    class="star-button text-center addtolist borderless-button"
                    (click)="
                        selectedChange(result);
                        doToList($event, result.value, true);
                        toggleDropdown = !toggleDropdown
                    "
                    tabindex="-1"
                >
                    <cmps-icon svgIcon="star-outline"></cmps-icon>
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template
        #optionTpl
        let-option="option"
    >
        <div class="option-image">
            <cmps-icon svgIcon="account-circle"></cmps-icon>
        </div>
        <div class="option-content col-md-10">
            <div class="row">
                <div class="option-text col-md-11">
                    {{ option.label }}
                </div>
            </div>
            <div class="row">
                <div class="option-sub-text">
                    {{ option.value }}
                </div>
            </div>
            <div class="option-actions">
                <button
                    class="borderless-button"
                    tabindex="-1"
                    (click)="doToList($event, option.value, false)"
                >
                    <cmps-icon svgIcon="star"></cmps-icon>
                </button>
            </div>
        </div>
    </ng-template>

    <div nodata>
        <span>{{ i18n._7410_NO_FAVOURITES_SAVED | translate }}.</span>
    </div>
</cmps-ui-dropdown>
